module.exports = __webpack_public_path__ + "img/logo_black.6be07a57.svg";